import Cookies from 'universal-cookie';

const USER_TOKEN_COOKIE = 'mfo-main-user';
const EMPTY_TOKEN: ITokenData = { accessToken: '' };

const cookies = new Cookies(null, { path: '/' });

/**
 * Флаги куки с токеном: `SameSite=Strict` — браузер не шлёт её с чужих сайтов,
 * `Secure` — только по HTTPS. На http (`pnpm dev` на localhost) `Secure` не ставится,
 * иначе браузер куку не сохранит.
 */
const getTokenCookieOptions = (): {
  path: string;
  sameSite: 'strict';
  secure: boolean;
} => ({
  path: '/',
  sameSite: 'strict',
  secure: window.location.protocol === 'https:'
});

/**
 * Проверяет, что значение из куки — токен сессии, а не мусор или чужой формат.
 * Лишние поля не мешают: в куках прошлых версий рядом лежал refreshToken.
 */
const isTokenData = (value: unknown): value is ITokenData =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as ITokenData).accessToken === 'string';

/**
 * Сохраняет accessToken в куку. JSON-сериализацию делает universal-cookie.
 * Refresh-токен здесь не хранится: бэкенд держит его в своей httpOnly-куке.
 */
export const setUserToken = (data: ITokenData): void =>
  cookies.set(
    USER_TOKEN_COOKIE,
    { accessToken: data.accessToken },
    getTokenCookieOptions()
  );

/**
 * Токен сессии из куки. universal-cookie сам разбирает JSON-значение, поэтому
 * повторный `JSON.parse` не нужен. Нет куки или она битая — пустой токен.
 */
export const getUserToken = (): ITokenData => {
  const value: unknown = cookies.get(USER_TOKEN_COOKIE);
  return isTokenData(value)
    ? { accessToken: value.accessToken }
    : { ...EMPTY_TOKEN };
};

export const removeUserToken = (): void =>
  cookies.remove(USER_TOKEN_COOKIE, getTokenCookieOptions());

interface ITokenData {
  accessToken: string;
}
